import { toTitleCase } from "../config/utils";
import {
    formatCapitalRequestSourceValue,
    getCapitalRequestLabel,
    getCapitalRequestNarrativeLabel,
    getCapitalRequestStatusLabel
} from "./capitalRequestLabel";

/** Display-only filter band title; internal band keys unchanged. */
export const getDashboardFilterBandLabel = (band, miscellaneous, isCR = false) => {
    if (!band) return "";
    if (isCR && band === "Recommendation") return getCapitalRequestLabel(miscellaneous);
    return band;
};

/** Display-only filter field title; API keys/params unchanged. */
export const getDashboardFilterFieldLabel = (field, miscellaneous, isCR = false) => {
    if (!field) return "";
    if (field.key === "infrastructure_requests") return getCapitalRequestLabel(miscellaneous);
    if (field.key === "cr_status") return getCapitalRequestStatusLabel(miscellaneous);
    if (isCR) {
        const crLabel = getCapitalRequestLabel(miscellaneous);
        if (field.key === "recommendation_type") return `${crLabel} Type`;
        if (field.key === "description") return crLabel;
        if (field.key === "notes") return getCapitalRequestNarrativeLabel(miscellaneous);
    }
    return field.label;
};

export const ASSET_LIFECYCLE_FILTER_NAME = "Asset Lifecycle";

export const ASSET_LIFECYCLE_OPTIONS = [
    { label: "Yes", value: "asset", name: "Asset" },
    { label: "No", value: "system", name: "System" }
];

/** Display labels for dashboard side panel / applied filters (Yes/No pill labels). */
export const getAssetLifecycleFilterLabels = values => {
    if (!Array.isArray(values) || !values.length) return [];
    return values.map(v => ASSET_LIFECYCLE_OPTIONS.find(opt => opt.value === v)?.label).filter(Boolean);
};

/** Display label for dashboard filter dropdown / applied filter values (ids unchanged). */
export const formatDashboardFilterOptionName = (name, key, miscellaneous) => {
    if (key === "source") {
        return formatCapitalRequestSourceValue(name, miscellaneous);
    }
    if (name === true || name === "true") return "Yes";
    if (name === false || name === "false") return "No";
    if (name == null || name === "") return name;
    if (typeof name !== "string" && typeof name !== "number") return name;
    return toTitleCase(String(name).replace(/_/g, " "));
};

export const formatDashboardFilterOptionNames = (values, key, miscellaneous) => {
    if (!Array.isArray(values)) return values;
    return values.map(v => formatDashboardFilterOptionName(v, key, miscellaneous));
};
